const IP_1 = '63.34.166.48';
const IP_2 = '52.50.173.226';
const IP_3 = '34.250.247.226';

export const ipList = [
  {
    label: 'IP 1',
    value: IP_1
  },
  {
    label: 'IP 2',
    value: IP_2
  },
  {
    label: 'IP 3',
    value: IP_3
  }
];

export const guideUrl =
  'https://cdn.prod.website-files.com/6044f1e731fd086115d71bf9/68ff6b5625ab7595b5056f92_Gui%CC%81a%20Payflow%20__%20Castilla.pdf';
